import React, { Component } from 'react';
import { Card, InputGroup, FormControl, FormGroup } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
    updateValue
} from '../actions/index';
import {
    MANUAL_AWARD_POINTS,
    NO_CALL_OFF_POINTS,
    NO_CALL_OFF_SHIFTS,
    ON_TIME_POINTS,
    QUARTERLY,
    SHIFTS_PICKED_UP,
    SURVEY
} from '../actions/types';

class PrimaryParameters extends Component {

    render() {
        const { manualAwardPoints, noCallOffPoints, noCallOffShifts, onTimePoints, quarterly, survey, updateValue } = this.props;
        return (
            <Card>
                <Card.Header className='card-title'>Reward Configuration</Card.Header>
                <InputGroup>
                    <FormGroup controlid="noCallOffsShifts">
                        <label>Consecutive No Call-Offs Shifts:</label>
                        <FormControl className='input-field' onChange={(event) => updateValue(event, NO_CALL_OFF_SHIFTS)} defaultValue={noCallOffShifts} />
                    </FormGroup>
                </InputGroup>
                <InputGroup>
                    <FormGroup controlid="noCallOffsPoints">
                        <label>Consecutive No Call-Offs Points Awarded:</label>
                        <FormControl className='input-field' onChange={(event) => updateValue(event, NO_CALL_OFF_POINTS)} defaultValue={noCallOffPoints} />
                    </FormGroup>
                </InputGroup>
                <InputGroup>
                    <FormGroup controlid="onTimePoints">
                        <label>On-Time Shift Points Awarded:</label>
                        <FormControl className='input-field' onChange={(event) => updateValue(event, ON_TIME_POINTS)} defaultValue={onTimePoints} />
                    </FormGroup>
                </InputGroup>
                <InputGroup>
                    <FormGroup controlid="survey">
                        <label>Complete Survey Instance:</label>
                        <FormControl className='input-field' onChange={(event) => updateValue(event, SURVEY)} defaultValue={survey} />
                    </FormGroup>
                </InputGroup>
                <InputGroup>
                    <FormGroup controlid="quarterly">
                        <label>Quarterly Tenure for 6 or more months:</label>
                        <FormControl className='input-field' onChange={(event) => updateValue(event, QUARTERLY)} defaultValue={quarterly} />
                    </FormGroup>
                </InputGroup>
                <InputGroup>
                    <FormGroup controlid="manualAwardPoints">
                        <label>Manual Awards:</label>
                        <FormControl className='input-field' onChange={(event) => updateValue(event, MANUAL_AWARD_POINTS)} defaultValue={manualAwardPoints} />
                    </FormGroup>
                </InputGroup>
                {/* Temporarily commented out for 0.8.2
                <FormGroup controlid="shiftsPickedUp">
                    <label>Shifts Picked Up</label>
                    <FormControl componentclass="input" onChange={(event) => updateValue(event, SHIFTS_PICKED_UP)} defaultValue={shiftsPickedUp} />
                </FormGroup>
                */}
            </Card>
        );
    }
}

PrimaryParameters.propTypes = {
    manualAwardPoints: PropTypes.number,
    noCallOffPoints: PropTypes.number,
    noCallOffShifts: PropTypes.number,
    onTimePoints: PropTypes.number,
    quarterly: PropTypes.number,
    survey: PropTypes.number,
    shiftsPickedUp: PropTypes.number,
    updateValue: PropTypes.func
};

function mapStateToProps(state) {
    return {
        manualAwardPoints: state.calc.get(MANUAL_AWARD_POINTS),
        noCallOffPoints: state.calc.get(NO_CALL_OFF_POINTS),
        noCallOffShifts: state.calc.get(NO_CALL_OFF_SHIFTS),
        onTimePoints: state.calc.get(ON_TIME_POINTS),
        quarterly: state.calc.get(QUARTERLY),
        shiftsPickedUp: state.calc.get(SHIFTS_PICKED_UP),
        survey: state.calc.get(SURVEY)
    };
}

export default connect(mapStateToProps, {
    updateValue
})(PrimaryParameters);
